import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeTimeFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.TIME),
  acceptedTimes: z
    .array(
      z.object({
        from: z.string(),
        to: z.string(),
      }),
    )
    .default([])
    .optional(),
  interval: z.string().optional(),
});
